

























import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import i18n from '@/plugins/i18n';

const DEFAULT_VALUE: string = '0';

const DEFAULT_VISIBILITY: boolean = false;

const DEFAULT_CORRECT: boolean = false;

@Component
export default class SelectComponent extends Vue {
  @Prop()
  public options: { [value: string]: string };

  @Prop({
    default: DEFAULT_VALUE
  })
  public selectedValue: string;

  @Prop({
    default: false
  })
  public evaluated: boolean;

  @Prop({
    default: DEFAULT_CORRECT
  })
  public correct: boolean;

  public value: string;

  public label: string = this.getLabel();

  public visible: boolean = DEFAULT_VISIBILITY;

  public mounted(): void {
    this.value = this.selectedValue;
    this.label = this.getLabel();
  }

  @Emit('change')
  public emitChange(): any {
    return this.value;
  }

  public setDefaultValue(): void {
    this.value = DEFAULT_VALUE;
    this.label = this.defaultLabel();
    this.visible = DEFAULT_VISIBILITY;
    this.correct = DEFAULT_CORRECT;
  }

  public toggle(): void {
    if (!this.evaluated) {
      this.visible = !this.visible;
    }
  }

  public selectOption(value: string, label: string): void {
    this.value = value;
    this.label = label;
  }

  private getLabel(): string {
    if (this.value === DEFAULT_VALUE) {
      return this.defaultLabel();
    }

    if (this.options[this.value]) {
      return this.options[this.value];
    }

    return this.defaultLabel();
  }

  private defaultLabel() {
    return i18n.t('select.default_label').toString();
  }
}
